let isProduction;

//*
isProduction = process.env.NODE_ENV !== 'development';
/*/
isProduction = false;
//*/

export const VERSION = '0.1.0';
export const BUILD = 'd5aafb1';

export const USE_DEFAULT_LANGUAGE = true;
export const DEFAULT_LANGUAGE = 'en';

export const DOMAIN = 'developmentglaze.com';

export const MAIN_URL = `//${DOMAIN}`;
export const USER_URL = `//user.${DOMAIN}`;
export const PREVIEW_URL = `//preview.${DOMAIN}`;

const LOCALHOST = 'localhost';

let adminUrl;
let apiUrl;
let appUrl;

if (isProduction) {
  adminUrl = `//paintingtool-api.${DOMAIN}/api`;
  apiUrl = `//paintingtool-api.${DOMAIN}`;
  appUrl = `//paintingtool-app.${DOMAIN}`;
} else {
  adminUrl = `//${LOCALHOST}:7788/api`;
  apiUrl = `//${LOCALHOST}:7788`;
  appUrl = `//${LOCALHOST}:3030`;
}

export const ADMIN_URL = adminUrl;
export const API_URL = apiUrl;
export const APP_URL = appUrl;
export const IS_PRODUCTION = isProduction;

export const AUTH_TOKEN_NAME = 'authToken';
export const MAIN_COMPANY_NAME = 'glaze';

export const AVAILABLE_COMPANIES = [MAIN_COMPANY_NAME, 'wilanow'];

export const AUTO_HIDING_NAME = 'auto-hiding';

export const VERIFY_DEVICE = false;

export const CACHE_IMAGES = true;

export const DEFAULT_PREMIUM_STATUS_FOR_COMPANY = true;

export const HIDE_CONSOLE_LOGS = false;

export const HIDE_STATUS_JS = false;

export const LOG_ROCKET_KEY = undefined; //'tijsmg/glaze';
